import React from 'react'
import ListAppointments from '../../components/appointments/ListAppointments'
import MainLayout from '../../layout/MainLayout'

const ListAppointmentsPage = () => {
  return (
    <MainLayout>
        <ListAppointments />
    </MainLayout>
  )
}

export default ListAppointmentsPage